<template>
  <div>
    <b-row>
      <b-col cols="8">
        <Widget>
          -<h3>Free Doctor<span class="fw-semi-bold">Schedules</span></h3>
          <p>
            Table of doctors available for free requests
          </p>
          <div class="table-responsive">
            <table class="table table-lg mb-0 requests-table table-hover">
              <thead>
              <tr class="text-muted">
                <th width="20%"><span class="fw-bold">Doctor</span></th>
                <th width="20%"><span class="fw-bold">Start Time</span></th>
                <th width="20%"><span class="fw-bold">End Time</span></th>
                <th width="10%"><span class="fw-bold">Slots Left</span></th>
                <th width="10%"><span class="fw-bold">Action(s)</span></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="freeDoctorSchedule in freeDoctorSchedules" :key="freeDoctorSchedule.id">
                <td>
                <span>
                  <b>{{ freeDoctorSchedule.doctor.name }}</b> ( {{
                    getdoctortype().find((dt) => dt.id === freeDoctorSchedule.doctor.doctortype_id).name
                  }} )
                  [ {{ freeDoctorSchedule.doctor.user.mobile }} ]</span>
                </td>
                <td>{{ freeDoctorSchedule.start_time }}</td>
                <td>{{ freeDoctorSchedule.end_time }}</td>
                <td>{{ freeDoctorSchedule.slots_left }}</td>
                <td>
                  <b-button @click="selectedSchedule = freeDoctorSchedule"
                            variant="success"
                            class="p-1 px-3 btn-xs">
                    set user
                  </b-button>

                </td>
              </tr>
              </tbody>
            </table>

          </div>
          <b-pagination
              v-model="currentPage"
              :total-rows="tableRows"
              :per-page="perPage"
              first-number
              @input="fetchFreeDoctorSchedules"
          ></b-pagination>
        </Widget>
      </b-col>
      <b-col>

        <div v-if="selectedSchedule">
          <Widget>
          <span><b>{{ selectedSchedule.doctor.name }}</b>
            ( {{ getdoctortype().find((dt) => dt.id === selectedSchedule.doctor.doctortype_id).name }} )
          [ {{ selectedSchedule.doctor.user.mobile }} ]
          </span>
            <p>
              {{ selectedSchedule.start_time }} - {{ selectedSchedule.end_time }}
            </p>

            <b-button @click="createFreeAppointments"
                      variant="success"
                      class="p-1 px-3 btn-xs">
              create appointments
            </b-button>
            <div class="table-responsive">
              <table class="table table-lg mb-0 requests-table table-hover">
                <thead>
                <tr class="text-muted">
                  <th width="20%"><span class="fw-bold">Start</span></th>
                  <th width="20%"><span class="fw-bold">User</span></th>
                  <th width="20%"><span class="fw-bold">Action(s)</span></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(scheduleSlot, i) in getAvailableSlots" :key="i">
                  <td>
                    {{ scheduleSlot.time }}
                  </td>
                  <td>
                    <span>{{ scheduleSlot.patient ? scheduleSlot.patient.user.mobile : '' }}</span>
                  </td>
                  <td>
                    <b-button @click="openUserSelectModal(scheduleSlot)"
                              variant="success"
                              class="p-1 px-3 btn-xs">
                      set user

                      <b-modal v-model="showUserSelectModal" centered title="Ekhoni Daktar" hide-footer>
                        <div class="table-responsive">
                          <table class="table table-lg mb-0 requests-table table-hover">
                            <thead>
                            <tr class="text-muted">
                              <th width="20%"><span class="fw-bold">Patient</span></th>
                              <th width="20%"><span class="fw-bold">User</span></th>
                              <th width="10%"><span class="fw-bold">Action(s)</span></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="freeRequest in freeRequests" :key="freeRequest.id">
                              <td>
                                <span>{{ freeRequest.patient.name }}: age {{ freeRequest.patient.age }}</span>
                              </td>
                              <td>
                                <span>{{ freeRequest.patient.user.mobile }}</span>
                              </td>
                              <td>
                                <b-button @click="selectPatientForFreeCall(freeRequest.patient)"
                                          variant="success"
                                          class="p-1 px-3 btn-xs">
                                  select
                                </b-button>

                              </td>
                            </tr>
                            </tbody>
                          </table>

                        </div>
                        <b-pagination
                            v-model="currentFreeRequestPage"
                            :total-rows="requestRows"
                            :per-page="requestsPerPage"
                            first-number
                            @input="fetchFreeRequests"
                        ></b-pagination>
                      </b-modal>

                    </b-button>

                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </Widget>
        </div>
      </b-col>

    </b-row>

  </div>

</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
import DoctorService from "@/services/admin/doctor.service";
import CheckupService from "@/services/checkup.service";

export default {
  name: "FreeRequests",
  data() {
    return {
      showUserSelectModal: false,
      selectedSchedule: null,
      selectedSlot: null,
      currentPage: 1,
      tableRows: 100,
      perPage: 5,
      freeDoctorSchedules: [],
      currentFreeRequestPage: 1,
      requestsPerPage: 1,
      requestRows: 1,
      freeRequests: [],
    };
  },
  computed: {
    getAvailableSlots: function () {
      return this.selectedSchedule.schedule_slots.filter((s) => !s.status)
    }
  },
  methods: {
    ...mapGetters('adminAuth', ['getdoctortype']),
    openUserSelectModal(scheduleSlot) {
      this.showUserSelectModal = true;
      this.selectedSlot = scheduleSlot;
      this.fetchFreeRequests();
    },

    selectPatientForFreeCall(patient) {
      this.selectedSlot.patient = patient;
      this.showUserSelectModal = false;
    },

    fetchFreeDoctorSchedules() {
      DoctorService.fetchPaginatedFreeSchedules(this.currentPage)
          .then((response) => {
            if (response.status === 200) {
              this.perPage = response.data.per_page;
              this.tableRows = response.data.total;
              this.freeDoctorSchedules = response.data.data.map((ds) => {
                ds.schedule_slots = JSON.parse(ds.schedule_slots);
                return ds;
              });
            }
          })
    },

    fetchFreeRequests() {
      DoctorService.fetchPagintedFreeRequestsBySchedule(this.selectedSchedule.id, this.currentFreeRequestPage)
          .then((response) => {
            if (response.status === 200) {
              this.requestsPerPage = response.data.per_page;
              this.requestRows = response.data.total;
              this.freeRequests = response.data.data;
            }
          })
    },
    createFreeAppointments() {
      let requests = []
      let doctor = this.selectedSchedule.doctor;
      this.selectedSchedule.schedule_slots.forEach((scheduleSlot) => {
        if(scheduleSlot.patient){
          requests.push(CheckupService.createAppointment({
            type: 0,
            doctor_id: doctor.id,
            patient_id: scheduleSlot.patient.id,
            start_time: scheduleSlot.time,
            end_time: ''
          }))
        }
      })

      axios.all(requests)
          .then(axios.spread((...responses) => {

            if (responses.every((r) => r.status === 201)) {
              this.selectedSchedule = null;
              this.fetchFreeDoctorSchedules();
            }
          }))
    }
  },
  mounted() {
    this.fetchFreeDoctorSchedules();
  }
}
</script>

<style scoped>

</style>
